import camelcaseKeys from 'camelcase-keys';
import { QueryKey, TokenGrantType, ContentType } from '../consts/index.mjs';

const fetchTokenByAuthorizationCode = async ({ clientId, tokenEndpoint, redirectUri, codeVerifier, code, resource, }, requester) => {
    const parameters = new URLSearchParams();
    parameters.append(QueryKey.ClientId, clientId);
    parameters.append(QueryKey.Code, code);
    parameters.append(QueryKey.CodeVerifier, codeVerifier);
    parameters.append(QueryKey.RedirectUri, redirectUri);
    parameters.append(QueryKey.GrantType, TokenGrantType.AuthorizationCode);
    if (resource) {
        parameters.append(QueryKey.Resource, resource);
    }
    const snakeCaseCodeTokenResponse = await requester(tokenEndpoint, {
        method: 'POST',
        headers: ContentType.formUrlEncoded,
        body: parameters,
    });
    return camelcaseKeys(snakeCaseCodeTokenResponse);
};
const fetchTokenByRefreshToken = async ({ clientId, tokenEndpoint, refreshToken, resource, scopes }, requester) => {
    const parameters = new URLSearchParams();
    parameters.append(QueryKey.ClientId, clientId);
    parameters.append(QueryKey.RefreshToken, refreshToken);
    parameters.append(QueryKey.GrantType, TokenGrantType.RefreshToken);
    if (resource) {
        parameters.append(QueryKey.Resource, resource);
    }
    if (scopes?.length) {
        parameters.append(QueryKey.Scope, scopes.join(' '));
    }
    const snakeCaseRefreshTokenTokenResponse = await requester(tokenEndpoint, {
        method: 'POST',
        headers: ContentType.formUrlEncoded,
        body: parameters,
    });
    return camelcaseKeys(snakeCaseRefreshTokenTokenResponse);
};

export { fetchTokenByAuthorizationCode, fetchTokenByRefreshToken };
